import { CatalogEvents } from './catalog';
import { PostbackEvents } from './postback';

export const GlobalEvents = { ...PostbackEvents, ...CatalogEvents };

export * from './catalog';
export * from './postback';
